import { render, staticRenderFns } from "./TopNavi.vue?vue&type=template&id=10fc9d9f&"
import script from "./TopNavi.vue?vue&type=script&lang=js&"
export * from "./TopNavi.vue?vue&type=script&lang=js&"
import style0 from "./TopNavi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports